export default "<app-table [inputConfig]=\"config\"></app-table>\n"